import { memo } from 'react';

import PropTypes from 'prop-types';

import Tooltip from 'components/UI/Tooltip/Tooltip';
import Typography from 'components/UI/Typography/Typography';

import { ReactComponent as InfoIcon } from 'images/Icons/Info.svg';

import styles from './Step.module.scss';

const Step = ({ title, description, tooltipText, children }) => (
  <div className={styles.root}>
    <div className={styles.headings}>
      <div className={styles.titleWrapper}>
        <Typography weight="semibold">{title}</Typography>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <InfoIcon />
          </Tooltip>
        )}
      </div>
      <Typography color="grey">{description}</Typography>
    </div>
    {children}
  </div>
);

Step.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  description: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(Step);
